import logError from 'utils/errorLogger'

export const getChargeEnum = (status: string) => {
  switch (status) {
    case 'boleto':
      return 'Boleto'
    case 'cash':
      return 'Dinheiro'
    case 'credit_card':
      return 'Cartão de crédito'
    case 'other':
      return 'Outros'
    case 'bonified_credit':
      return 'Bonificação'
    case 'pix':
      return 'Pix'
    case 'transfer':
      return 'Transferência (TED/DOC)'
    case 'credit_card_recurring':
      return 'Cartão recorrente'
    case 'credit_card_installments':
      return 'Cartão parcelado'
    case 'boleto_pix':
      return 'Pix'
    case 'direct_payment':
      return 'Recebimento manual'
    default:
      logError(`Erro ao mapear tradução de status de planos: ${status}`)
      return 'Status desconhecido'
  }
}

// Filtros que o relatório "cobranças do plano" entende. Os filtros da tabela
// ficam num state local com `sort` (objeto) e chaves vazias; mandar isso cru
// virava "sort=[object Object]" no filter_by e o back perdia até o plano.
export const buildProductChargeReportFilters = (
  filters: { name?: string; document?: string; cycles?: string },
  productUuid?: string
) => ({
  product_uuid: productUuid,
  ...(filters?.name && { name: filters.name }),
  ...(filters?.document && { document: filters.document }),
  ...(filters?.cycles && { cycles: filters.cycles })
})
